import { apiSlice } from "./ApiSlice";

const GetoutpatientApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    Getoutpatient: builder.query({
      query: (clinicUserId) => {
        
        return {
          url: `/api/ClinicProfile/GetOutPatientsListView?userClinicID=${clinicUserId}`,
          method: "GET"
        };
      },
    }),

    getOutPatientDetails: builder.query({
      query: ({ appointmentId, patientUserUniqueID }) => ({
        url: `/api/ClinicProfile/GetOutPatientCompleteDetails?appointmentId=${appointmentId}&patientUserUniqueID=${patientUserUniqueID}`,
        method: "GET",
      }),
    }),

    GetPatientsDoctorside: builder.query({
      query: ({ clinicUserId, DoctorUserUniqueID }) => ({
        url: `/api/ClinicProfile/GetOutPatientsListView?userClinicID=${clinicUserId}&DoctorUserUniqueID=${DoctorUserUniqueID}`,
        method: "GET",
      }),
    }),

    GetTreatmentplan: builder.mutation({
  query: (data) => ({
    url: `/api/ClinicProfile/TreatmentplansTableFilter`,
    method: "POST",
     body: data,
  }),
}),

 PostFilteredOutpatients: builder.mutation({
      query: (data) => ({
        url: `api/ClinicProfile/OutpatientsTableFilter`,
        method: "POST",
        body: data,
      }),
    }),

  }),
});

export const { useLazyGetoutpatientQuery, usePostFilteredOutpatientsMutation, useGetOutPatientDetailsQuery,useLazyGetPatientsDoctorsideQuery, useGetTreatmentplanMutation } = GetoutpatientApiSlice;